import { render, staticRenderFns } from "./EditZone.vue?vue&type=template&id=159cbb6b&"
import script from "./EditZone.vue?vue&type=script&lang=js&"
export * from "./EditZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports